import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useMutation, useLazyQuery } from 'react-apollo';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import DadosPagamentoAlternativoForm from './DadosPagamentoAlternativoForm';
import { SAVE_DADOS_PAGAMENTO_ALTERNATIVO_PROFISSIONAL } from '../../../../graphql/mutations';
import { FIND_BY_ID_PROFISSIONAL_SAUDE_DADOS_PAGAMENTO } from '../../../../graphql/queryes';

const ModalDadosPagamentoAlternativoProfissional = ({ profissional, onClose, onSuccess }) => {
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);
  const [dados, setDados] = useState({ id: null, slug: '', walletId: '', percentualRepasse: '' });
  const [loading, setLoading] = useState(true);

  const [buscarDados] = useLazyQuery(FIND_BY_ID_PROFISSIONAL_SAUDE_DADOS_PAGAMENTO, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      const list = data?.findByIdProfissionalSaude?.dadosPagamentoAlternativo;
      const d = Array.isArray(list) ? list[0] : list;
      setDados({
        id: d?.id || null,
        slug: d?.slug || '',
        walletId: d?.walletId || '',
        percentualRepasse: d?.percentualRepasse ?? '',
      });
      setLoading(false);
    },
    onError: (e) => { console.log('onError:', e); setLoading(false); },
  });

  useEffect(() => {
    if (profissional?.id) {
      buscarDados({ variables: { id: profissional.id } });
    } else {
      setLoading(false);
    }
  }, []);

  const [saveDados] = useMutation(SAVE_DADOS_PAGAMENTO_ALTERNATIVO_PROFISSIONAL);

  const handleSalvar = async () => {
    if (!dados.slug) return;
    try {
      setSalvando(true);
      setErro(null);
      await saveDados({
        variables: {
          profissionalSaudeId: profissional.id,
          dadosPagamentoAlternativo: {
            id: dados.id || undefined,
            slug: dados.slug,
            walletId: dados.walletId || null,
            percentualRepasse: dados.percentualRepasse !== '' ? Number(dados.percentualRepasse) : null,
          },
        },
      });
      onSuccess && onSuccess();
      onClose && onClose();
    } catch (e) {
      setErro(e?.graphQLErrors?.[0]?.message || 'Erro ao salvar.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Container>
      <Title>Dados de Pagamento Alternativo — {profissional?.nome}</Title>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <DadosPagamentoAlternativoForm dados={dados} onChange={setDados} />
      )}
      {erro && <Erro>{erro}</Erro>}
      <Actions>
        <Button onClick={onClose} disabled={salvando}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSalvar}
          disabled={salvando || !dados?.slug}
        >
          {salvando ? <CircularProgress size={18} /> : 'Salvar'}
        </Button>
      </Actions>
    </Container>
  );
};

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

const Erro = styled.span`
  color: red;
  font-size: 13px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export default ModalDadosPagamentoAlternativoProfissional;
